import generalApi from '@/api/generalApi.js'
import registerApiMail from '@/api/registerApiMail.js'

import sanitizeTitle from '@/modules/atletas/helpers/slug.js'

export const setAtletas = async ({ commit }, evento) => {
    const atletas = await generalApi.get(`/v1/atleta/${evento}/categoria`)
    const a = atletas.data.atletas
    const e = atletas.data.evento
    const c = atletas.data.categorias
    const es = atletas.data.estados
    const cl = atletas.data.clubs
    commit('mutAtletas', [a, e, c, es, cl])
}

export const setAtletasInscripciones = async ({ commit }, evento) => {
    const atletas = await generalApi.get(`/v1/atleta/${evento}/inscripciones`)

    const a = atletas.data.atletas
    const e = atletas.data.evento
    const c = atletas.data.categorias
    const es = atletas.data.estados
    const pen = atletas.data.pendientes
    const p = atletas.data.pago
    const dorsales = atletas.data.evento.dorsales
    const d = atletas.data.evento.dorsales
    
    var f = []
    var m = []

    
    if(e.habilitar_dorsales_sexo == '1'){
        var dor = dorsales.split(',')
        var dis = []
        var caminata = []
        if(e.distancia  != null) dis.push(e.distancia)
        if(e.distancia2 != null) dis.push(e.distancia2) 
        if(e.distancia3 != null) dis.push(e.distancia3)
        if(e.distancia4 != null) dis.push(e.distancia4) 
        if(e.distancia5 != null) dis.push(e.distancia5) 

        for (let i = 0; i < a.length; i++) {
            if(dis[1] == a[i].distancia && a[i].validar_pago == '1' && a[i].nrocorredor == '000'){
                if(a[i].sexo === 'F'){
                    f.push(a[i])
                }else{
                    m.push(a[i])
                }
            }else{
                if(a[i].validar_pago == '1' && a[i].nrocorredor == '000'){
                    caminata.push(a[i])
                }
            }
        }
        var datos = []
        
        for (let d = 0; d < dor.length; d++) {
            datos.push(dor[d].split('-'))                            
        }
    }

    //DISTANCIAS
    const dist = []
    if(e.distancia  != '' && e.distancia  != null && e.distancia  != undefined ){ dist.push(e.distancia) }
    if(e.distancia2 != '' && e.distancia2 != null && e.distancia2 != undefined ){ dist.push(e.distancia2)}
    if(e.distancia3 != '' && e.distancia3 != null && e.distancia3 != undefined ){ dist.push(e.distancia3)}
    if(e.distancia4 != '' && e.distancia4 != null && e.distancia4 != undefined ){ dist.push(e.distancia4)}
    if(e.distancia5 != '' && e.distancia5 != null && e.distancia5 != undefined ){ dist.push(e.distancia5)}
    
    if(e.habilitar_dorsales_sexo == '1'){
        commit('mutAtletas3', [a, e, c, es, pen, p, d, f, m, caminata, dis, datos])
    }else{
        commit('mutAtletas2', [a, e, c, es, pen, p, d, f, m])
    }
}

export const selectAtleta = async ({ commit }, id) => {
    commit('selectAtleta', id)
}

export const selectCategoria = async ({ commit }, categoria) => {
    commit('selectCategoria', categoria)
}

export const atletaseleccionado = ({ commit }, atleta) => {
    commit('selectAtleta', atleta)
}

export const selectedEvento = ({ commit }, evento) => {
    commit('selectedEvento', evento)
}

export const selectedEventoInscripciones = ({ commit }, evento) => {
    commit('selectedEvento', evento)
}

export const seledEvento = ({ commit }, evento) => {
    commit('selectedEvento', evento)
}

export const updateAtleta = async ({ commit }, atleta) => {
    const resp = await generalApi.put(`/v1/atleta/${atleta[1]}`, atleta[0])
    return resp.data
}

export const updatePago = async ({ commit }, dato) => {
    const resp = await generalApi.put(`/v1/pago/${dato.id}`, dato.pago)
    return resp.data
}


export const createAtleta = async ({ commit }, atleta) => {
    const resp = await generalApi.post(`/v1/atleta/register`, atleta)
    if (resp.data) {
        if (resp.data.token) {
            const { dato } = await registerApiMail.get(`/registro?token=${resp.data.token}`)
        }
    }
    return resp.data
}
export const deleteAtleta = async ({ commit }, id) => {
    const resp = await generalApi.delete(`/v1/atleta/${id}`)
    commit('deleteAtleta', id)
    return resp.data
}

export const confirmarIncorporarId = async ({ commit }, dato) => {
    const resp = await generalApi.get(`/v1/atleta/${dato.id}/restore`)
    commit('restaurarAtleta', dato.id)
    return resp.data
}

export const confirmarPagoId = async ({ commit }, id) => {
    const data = await generalApi.post(`/v1/atleta/${id}/confirmar-pago`)
    commit('confirmarPagoId', id)
    return data
}

export const AsignarDorsal = async ({ commit }, dato) => {
    const data = await generalApi.post(`/v1/atleta/${dato.id}/asignar-dorsal`, dato)
    /*if (data.data) {
        if (data.data.token) {
            const { dato } = await registerApiMail.get(`/dorsal?token=${data.data.token}`)
        }
    }*/
    return data
}
/*
export const confirmarPagoId = async ({ commit }, dorsal, id) => {
    await generalApi.post(`/v1/atleta/${id}/confirmar-pago`)
    commit('confirmarPagoId', id)
    return id
}*/


export const vaciar = async ({ commit }, id) => {
    await generalApi.delete(`/v1/atleta/vaciar/${id}`)
    commit('vaciar')
    return id
}
export const vaciarpendientes = async ({ commit }, id) => {
    const data = await generalApi.delete(`/v1/atleta/vaciarpendientes/${id}`)
    commit('vaciarPendientes')
    return data.data
}
export const vaciarInscritos = async ({ commit }, id) => {
    const data = await generalApi.delete(`/v1/atleta/vaciar-inscritos/${id}`)
    commit('vaciarInscritos')
    return data.data
}

export const setCats = ({ commit }, data) => {
    commit('setCategorias', data)
}


export const exportar = async ({ commit }, datos) => {
    const hast = localStorage.getItem('api_token')
    if (hast) {
        const resp = await generalApi.get(`/v1/evento/export/${datos.id}?tipo=${datos.tipo}&cat=${datos.cat}&dis=${datos.dis}`)
        return resp.data
    } else {
        localStorage.removeItem('hast_token')
    }
}
// export const exportEvento = async ({commit}, datos) => {
//     console.log('datos: ', datos)
//     const data = await generalApi.get(`/v1/evento/export/${datos.id}?tipo=${datos.tipo}&cat=${datos.cat}&dis=${datos.dis}`)

//     return data.data
//     //console.log('data: ', data)
//     //commit('mutEventos', eventos.data)
// } 

export const setMenu = async ({ commit }, valor) => {
    commit('setMenu', valor)
}


export const setDisDor = async ({commit}, datos) => {
    commit('setDisDor', datos)
}

export const setAtletasDistancia = async ({commit}, datos) => {
    commit('setAtletasDistancia',  datos )
}
